module.exports = __webpack_public_path__ + "static/assets/c3a88fa1746d8e5169db188302979317.svg";